const KEY_MAPPING = {
  polygon_type: 'polygonType',
  smart_low_poly: 'isSmartLowPoly',
  material: 'material',
  file_format: 'fileFormat',
}

function matchProperties(properties, modelSettings) {
  return Object.entries(properties).every(([key, condition]) => {
    const value = modelSettings[KEY_MAPPING[key]]
    if ('const' in condition) {
      return value === condition.const
    }

    if ('enum' in condition) {
      return condition.enum.includes(value)
    }

    return true
  })
}

function ifMatches(ifSchema, modelSettings) {
  if (!ifSchema?.properties) {
    return true
  }

  return matchProperties(ifSchema.properties, modelSettings)
}

export default function matchesActiveIf(schema, modelSettings) {
  const activeIf = schema.active_if
  if (!activeIf) {
    return true
  }

  if (activeIf.properties && !matchProperties(activeIf.properties, modelSettings)) {
    return false
  }

  const allOf = activeIf.allOf || []
  return allOf.every((entry) => {
    if (!ifMatches(entry.if, modelSettings)) {
      return true
    }

    if (entry.then?.properties) {
      return matchProperties(entry.then.properties, modelSettings)
    }

    return true
  })
}
